import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { FaFileArchive } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { AiFillEye } from "react-icons/ai";
import "./UserToUpdate.css";

const GrillaUserAlerts = ({ data }) => {
  const [alertUser, setAlertUser] = useState(data);
  const navigate = useNavigate();

  /*DAR DE BAJA A PERSONA HUMANA Y JURIDICA */
  const handleCasualty = async (e, identify, entityType) => {
    const id = identify;
    e.preventDefault();
    const endpoint =
      entityType === "Persona Humana"
        ? `${process.env.REACT_APP_LEALTAD_CASUALTY_PERSON_API}`
        : `${process.env.REACT_APP_LEALTAD_CASUALTY_COMPANY_API}`;
    try {
      const res = await axios.post(endpoint, {
        id,
        newStatus: "Baja",
      });

      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Correcto",
          text: res.data.message,
        });
        setAlertUser((prevAlertMessage) =>
          prevAlertMessage.filter((user) => user.identify !== identify)
        );
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.message,
      });
    }
  };

  /*EN BASE AL DNI Y LA RELACION LLEVA AL USUARIO A LA VISTA DE INFORMACION DE USUARIO*/
  const handleSearch = async (e, identify, relation) => {
    e.preventDefault();
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_LEALTAD_SEARCH_USER_API}?id=${identify}&relation=${relation}`
      );
      if (res.data) {
        navigate("/lealtad/informe", { state: res.data });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se encontró el usuario.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.response.data.message,
      });
    }
  };

  /*ACTUALIZAR POR NOSIS*/
  const handlerUpdate = async (e, identify, entityType) => {
    const id = identify;
    e.preventDefault();
    const endpoint =
      entityType === "Persona Humana"
        ? `${process.env.REACT_APP_LEALTAD_UPDATE_USER_API}`
        : `${process.env.REACT_APP_LEALTAD_UPDATE_COMPANY_API}`;
    try {
      const res = await axios.post(endpoint, {
        id,
      });

      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Correcto",
          text: res.data.message,
        });
        setAlertUser((prevAlertMessage) =>
          prevAlertMessage.filter((user) => user.identify !== identify)
        );
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.message,
      });
    }
  };

  /*PASAR PARAMENTROS DNI Y TIPO DE USUARIOS (LA ACTUAL ESTA MAL)*/
  const handleClick = (e, identify, relation) => {
    e.preventDefault();
    handleSearch(e, identify, relation);
  };

  const typeUser = (alertUser) => {
    if (alertUser.identify) {
      return alertUser.identify;
    }

    if (alertUser.identify) {
      return alertUser.identify;
    }
  };

  const typeRisk = (alertUser) => {
    if (alertUser.risk === "Riesgo alto") {
      return <p className="riskhigh-lealtad">Riesgo Alto</p>;
    }

    if (alertUser.risk === "Riesgo medio") {
      return <p className="riskmid-lealtad">Riesgo Medio</p>;
    }

    if (alertUser.risk === "Riesgo bajo") {
      return <p className="risklow-lealtad">Riesgo Bajo</p>;
    }
  };

  return (
    <div className="boxtableUserAlert-lealtad">
      <table className="tableUserAlerts-lealtad">
        <thead>
          <tr>
            <th className="tableUserHeader-lealtad">Riesgo</th>
            <th className="tableUserHeader-lealtad">Usuario</th>
            <th className="tableUserHeader-lealtad">Dni / Cuit</th>
            <th className="tableUserHeader-lealtad">Relacion con la Mutual</th>
            <th className="tableDocumentHeader-lealtad">Tipo de Usuario</th>
            <th className="tableUserHeader-lealtad">
              Fecha de vencimiento del perfil
            </th>
            <th className="tableUserHeader-lealtad">Actualizar</th>
            <th className="tableUserHeader-lealtad">Inactivar</th>
            <th className="tableUserHeader-lealtad">Perfil</th>
          </tr>
        </thead>
        <tbody>
          {alertUser.map((item, index) => {
            return (
              <tr key={index}>
                <td className="tableUserDataRisk-lealtad">{typeRisk(item)}</td>
                <td className="tableUserData-lealtad">{item.name}</td>
                <td className="tableUserData-lealtad">{typeUser(item)}</td>
                <td className="tableUserData-lealtad">{item.relation}</td>
                <td className="tableUserData-lealtad">{item.entityType}</td>
                <td className="tableUserData-lealtad">{item.expirestAt}</td>
                <td
                  className="tableUserData-lealtad"
                  onClick={(e) =>
                    handlerUpdate(e, item.identify, item.entityType)
                  }
                >
                  <FaFileArchive className="iconGrilla2-lealtad" />
                </td>
                <td
                  className="tableUserData-lealtad"
                  onClick={(e) =>
                    handleCasualty(e, item.identify, item.entityType)
                  }
                >
                  <MdDelete className="iconGrilla2-lealtad" />
                </td>
                <td
                  className="tableUserData-lealtad"
                  onClick={(e) => handleClick(e, item.identify, item.relation)}
                >
                  <AiFillEye className="iconGrilla2-lealtad" />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default GrillaUserAlerts;
